import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { SharedLanguageService } from '@language';
import { FieldDefinitionHelper } from '../../../core/field-definitions/helpers/field-definition.helper';
import { ExtendedBaseProfileField } from '../../../core/profiles/entities/extended-profile-field.entity';
import { Family, MergeStrategy } from '../../../core/records/entities/metadata/metadata.entity';
import { FormSelectOption } from '../../../form-controls/entities/form-select-option.entity';
import { FormSelectStyle } from '../../../form-controls/entities/form-select-style.entity';
import { toFormSelectOption } from '../../../form-controls/helpers/form-select-option-helper';

@Component({
    selector: 'sh-merge-strategy-control',
    templateUrl: './merge-strategy-control.component.html',
    styleUrls: ['./merge-strategy-control.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShMergeStrategyControlComponent implements OnInit {
    private readonly translateService: SharedLanguageService = inject(SharedLanguageService);

    public isListType!: boolean;
    public id!: string;
    public mergeStrategyControl!: UntypedFormControl;
    public mergeStrategyOptions: FormSelectOption[] = [
        toFormSelectOption(MergeStrategy.MERGE, this.translateService.translate('form.merge-strategy.merge')),
        toFormSelectOption(MergeStrategy.SUBTRACT, this.translateService.translate('form.merge-strategy.subtract'))
    ];

    public readonly formSelectStyle: typeof FormSelectStyle = FormSelectStyle;

    @Input() profileField!: ExtendedBaseProfileField;

    @Input() formGroup!: UntypedFormGroup;

    ngOnInit(): void {
        this.initListType();
        this.initFormControl();
        this.initStartValue();
    }

    private initListType() {
        this.isListType = FieldDefinitionHelper.IsList(this.profileField.FieldDefinition);
    }

    private initFormControl() {
        this.id = `${Family.MergeStrategies}.${this.profileField.FieldDefinition.DottedKey}`;

        this.mergeStrategyControl = new UntypedFormControl();
        this.formGroup.addControl(this.id, this.mergeStrategyControl);
    }

    private initStartValue() {
        if (this.isListType) {
            this.mergeStrategyControl.setValue(MergeStrategy.MERGE);
        } else {
            this.mergeStrategyControl.setValue(MergeStrategy.OVERWRITE);
        }
    }
}
